import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useFidelityTokenId } from '../hooks/useFidelityTokenId';

interface LoginDetailsDTO {
  firstname: string;
  lastname: string;
  dateofbirth: string;
  lastfourdigitsssn: string;
}

export interface LoginDetails {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  lastFourDigitsSSN: string;
}

interface Params {
  clientId: string;
  loginDetails: LoginDetails;
}

interface FidelityDocumentsAuthenticationTokenDTO {
  id: string;
  name: string;
}

const authenticateEntity = ({
  clientId,
  loginDetails,
}: Params): Promise<FidelityDocumentsAuthenticationTokenDTO> => {
  const body: LoginDetailsDTO = {
    firstname: loginDetails.firstName,
    lastname: loginDetails.lastName,
    dateofbirth: loginDetails.dateOfBirth,
    lastfourdigitsssn: loginDetails.lastFourDigitsSSN,
  };

  return authFetch(
    urlWithParams('/Consumer/DocumentVault/CreateFidelityUserLogin', {
      clientId,
    }),
    { method: 'POST', ...httpBodyOptions(body, true) },
  );
};

export const useAuthenticateEntityMutation = () => {
  const { setCurrentTokenId } = useFidelityTokenId();

  return useMutation<FidelityDocumentsAuthenticationTokenDTO, Error, Params>(authenticateEntity, {
    onSuccess(authenticationToken) {
      setCurrentTokenId(authenticationToken.id);
    },
  });
};
